// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"submitted_pageWrapper__1At9R","textWrapper":"submitted_textWrapper__rLlj_","whatNext":"submitted_whatNext__2jJpY"};